import { MemberStatusTypes, LifeCycleStagetypes } from '../../domain/member';
import { PaymentMethodTypes } from '../../domain/invoice';

export interface IMemberEditRequest {
    ID: number;
    FirstName: string;
    LastName: string;
    CompanyName: string;
    Phone1: string;
    Phone2: string;
    Fax: string;
    Email: string;
    Address1: string;
    State: string;
    Country: string;
    ZipCode: string;
    City: string;
    HubspotVID: string;
    AdminNote: string;
    LifeCycleStage: LifeCycleStagetypes;
    DefaultPayMethod: PaymentMethodTypes;
    Status: MemberStatusTypes;
    Password: string;
    Note: string;

    AuthorizedContactFirstName: string;
    AuthorizedContactLastName: string;
    AuthorizedContactEmail: string;
    AuthorizedContactNote: string;

    OverrideUpdaterClientSettings_ID: number;

    PreventAutomaticEmails?: number;
    ExemptFromTax?: boolean;
}

export class MemberEditRequest implements IMemberEditRequest {
    ID: number;
    CompanyName: string;
    Phone1: string;
    Phone2: string;
    Fax: string;
    Email: string;
    FirstName: string;
    LastName: string;
    Address1: string;
    State: string;
    Country: string;
    ZipCode: string;
    City: string;
    HubspotVID: string;
    AdminNote: string;
    LifeCycleStage: LifeCycleStagetypes;
    DefaultPayMethod: PaymentMethodTypes;
    Status: MemberStatusTypes;
    Password: string;
    Note: string;

    AuthorizedContactFirstName: string;
    AuthorizedContactLastName: string;
    AuthorizedContactEmail: string;
    AuthorizedContactNote: string;

    OverrideUpdaterClientSettings_ID: number;

    PreventAutomaticEmails?: number;
    ExemptFromTax?: boolean;
}
